module.exports = __webpack_public_path__ + "static/media/slzhitui-fuwu-2.605ffa77.png";